import {
  GET_2359_REPORTS_REQUEST,
  GET_2359_REPORTS_SUCCESS,
  GET_2359_REPORTS_ERROR,
  GET_2359_REPORTS_FILTER,
} from './constants';
import { SecurityReport2359 } from './interfaces';

export const get2359ReportsRequest = (branchId: string) => ({
  type: GET_2359_REPORTS_REQUEST,
  payload: branchId,
});

export const get2359ReportsSuccess = (reports: SecurityReport2359[]) => ({
  type: GET_2359_REPORTS_SUCCESS,
  payload: { reports },
});

export const get2359ReportsError = (error: Error) => ({
  type: GET_2359_REPORTS_ERROR,
  payload: error,
});

export const set2359ReportsFilter = (reports: SecurityReport2359[]) => ({
  type: GET_2359_REPORTS_FILTER,
  payload: { reports },
});

export type Actions =
  | ReturnType<typeof set2359ReportsFilter>
  | ReturnType<typeof get2359ReportsRequest>
  | ReturnType<typeof get2359ReportsSuccess>
  | ReturnType<typeof get2359ReportsError>;
